<template>
  <div class="container notification-container">
    <div
      v-for="(notification, key) in notifications"
      :key="key"
      :class="['notification', `is-${notification.type}`]"
      :active.sync="notification.active"
    >
      <button class="delete" @click="removeNotification(key)"></button>
      {{ notification.text }}
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
export default {
  name: "Notifications",
  mounted() {
    this.interval = setInterval(this.cleanUp, 5000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  data() {
    return {
      interval: null,
    }
  },
  computed: {
    ...mapState(["notifications"]),
  },
  methods: {
    ...mapActions(["removeNotification"]),
    cleanUp() {
      this.$_.each(this.notifications, (notification, key) => {
        if (notification && notification.active) this.removeNotification(key)
      })
    },
  },
}
</script>

<style lang="sass">
.notification-container
  position: absolute
  right: 5px
  width: fit-content
  display: flex
  flex-direction: column
  bottom: 15px
  z-index: 99999
</style>
